import angular from 'angular'
import exportConfigData from './exportConfigData'
class exportModalCtrl {
  constructor(
    $scope,
    $uibModalInstance,
    config,
    httpRequest,
    $uibModal,
    invoiceType,
    billTypeTitle
  ) {
    console.log(billTypeTitle[0].label + invoiceType)
    $scope.invoiceType = invoiceType
    //票据种类
    $scope.exportTitle = billTypeTitle[0].label
    // 票据种类导出字段
    $scope.exportConfigData = exportConfigData
    $scope.config = getInvoiceKey(invoiceType)
    // 全选
    $scope.allChoose = function allChoose() {
      $scope.config.forEach((element) => {
        element.selected = $scope.selected
      })
    }
    // 单个
    $scope.changeChildChexbox = function () {
      let count = 0
      $scope.config.forEach((element) => {
        if (element.selected) count++
      })
      if (count == $scope.config.length) {
        $scope.selected = true
      } else {
        $scope.selected = false
      }
    }
    // $scope.config.profileType = invoiceType
    // 获取对应票据种类导出字段
    function getInvoiceKey(invoiceType) {
      let result = $scope.exportConfigData[invoiceType]
      if (!result) {
        let keys = Object.keys($scope.exportConfigData)
        for (let i = 0; i < keys.length; i++) {
          let item = keys[i]
          let itemKeys = item.split(',')
          for (let i = 0; i < itemKeys.length; i++) {
            if (itemKeys[i] == invoiceType) {
              result = $scope.exportConfigData[item]
              break
            }
          }
        }
      }
      return result
    }
    // 关闭
    $scope.cancel = function cancel() {
      $uibModalInstance.dismiss('cancel')
    }
    // 确定
    $scope.ok = function ok() {
      $uibModalInstance.close({
        config: $scope.config,
      })
    }
  }
}

exportModalCtrl.$inject = [
  '$scope',
  '$uibModalInstance',
  'config',
  'httpRequest',
  '$uibModal',
  'invoiceType',
  'billTypeTitle',
]
export default exportModalCtrl



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/management/exportModalCtrl.js